import React from 'react';
import {get} from 'lodash';
import {gql} from '@apollo/client';
import client from '../../src/graphql/client';
import styled from '@emotion/styled';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorRespImg from '../../src/data-restructure/ui/resp-img';
import seoQuery from '../../src/graphql/queries/seo';
import topo from '../../src/assets/topo.png';
import ModelSelectPageContainer from '../../src/containers/ModelSelectPageContainer';


const Container = styled.div`
    margin-top: 65px;
    padding: 65px 0;
    position: relative;
    &:before {
        height: 60px;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-position: center top;
        background-image: url(${topo});
        background-size: 400px auto;
        background-repeat: repeat-x;
  `

const BuildYourJayco = (props) => {
  return (
    <Container>
      <ModelSelectPageContainer
        {...props}
      />
    </Container>
  )
}

export async function getStaticProps() {
  //const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  //const region = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz'

  const GET_DATA = gql`
    query GET_DATA {
      pageBy(uri: "build-price") {
        title
        seo {
          ${seoQuery}
        }
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcBodyText {
              btHeading
              btBody
            }
          }
        }
        acf_build_and_price {
          bptHidePrice
        }
      }
      rangeListingsPageBy(uri: "range") {
        acf_range_listings_page {
          rangeListingsPageRangeRef {
            ... on Range {
              id
              title
              acf_range {
                rangeDescription
                rangeSeriesRef {
                  ... on Series {
                    id
                    uri
                    title
                    acf_series {
                      sleepingMax
                      seriesImage {
                        ${respImgQuery}
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `

  const gqData = await client.query({
    query: GET_DATA
  });
  
  //console.log('gqData>>>>', gqData);

  var ranges = [];
  get(gqData, 'data.rangeListingsPageBy.acf_range_listings_page.rangeListingsPageRangeRef', []).map((rItem => {
    var series = [];
    get(rItem, 'acf_range.rangeSeriesRef', []).map(sItem => {
      var sImg = get(sItem, 'acf_series.seriesImage', false);
      series.push({
        id: sItem.id,
        title: sItem.title,
        subTitle: singularize(rItem.title),
        sleeps: get(sItem, 'acf_series.sleepingMax', null),
        href: `/build-price/${sItem.uri}`,
        models: [],
        image: sImg ? refactorRespImg(sImg, [{
            size: 'default',
            key: 'image_size_520x280',
          },{
            size: 'md',
            key: 'image_size_704x514',
          }]): null,
      });
    });
    if (rItem.title.toLowerCase() !== 'motorised') {
      ranges.push({
        id: rItem.id,
        range: {
          title: rItem.title,
          text: get(rItem, 'acf_range.rangeDescription', null),
          series
        }
      });
    }
  }));
  
  const data = {
    meta: {
      title: get(gqData, 'data.pageBy.title', null),
      seo: get(gqData, 'data.pageBy.seo', null)
    },
    breadcrumbs: await refactorBreadcrumbsData('/build-price', null),
    disablePrice: get(gqData, 'data.pageBy.acf_build_and_price.bptHidePrice', null),
    title: get(gqData, 'data.pageBy.acf_content_builder.contentBuilder[0].btHeading', null),
    text: get(gqData, 'data.pageBy.acf_content_builder.contentBuilder[0].btBody', null),
    series: ranges,
  }

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      ...data,
      greyBg: true
    }
  }
}


function singularize(word) {
    const endings = {
        ves: 'fe',
        ies: 'y',
        i: 'us',
        zes: 'ze',
        ses: 's',
        es: 'e',
        s: ''
    };
    return word.replace(
        new RegExp(`(${Object.keys(endings).join('|')})$`), 
        r => endings[r]
    );
}
  
export default BuildYourJayco
  
